<script lang="ts">
    /**
     * @component
     * An inline field that toggles between display and edit mode.
     *
     * @prop {string} [content] - The text value to display and edit.
     * @prop {boolean} checked - The checkbox value to display and edit.
     * @prop {(val: string | boolean) => Promise<boolean>} callback - Called with the new value when the user confirms. Return `true` to exit edit mode.
     * @prop {boolean} [hasEditRights=false] - Whether the edit button is shown.
     */

    import BootstrapVectorIcon from "./BootstrapVectorIcon.svelte";

    let {
        content = $bindable(),
        checked = $bindable(),
        callback,
        hasEditRights = false,
        multiline = false,
        inputType = "text",
        trueLabel = "Enabled",
        falseLabel = "Disabled",
        checkboxLabel = "Enabled"
    }: {
        content?: string,
        checked?: boolean,
        callback: (val: string | boolean) => Promise<boolean>,
        hasEditRights?: boolean | Promise<boolean>,
        multiline?: boolean,
        inputType?: "text" | "checkbox",
        trueLabel?: string,
        falseLabel?: string,
        checkboxLabel?: string
    } = $props();


    let actualEditRights: boolean = $state(false);

    // Handle the promise
    $effect(() => {
        if(hasEditRights instanceof Promise) {
            hasEditRights.then((v: boolean) => {
                actualEditRights = v;
            });
        } else {
            actualEditRights = hasEditRights;
        }
    })

    let editMode: boolean = $state(false);
    let draftChecked: boolean = $state(false);
    function handleEditClick() {
        draftChecked = checked ?? false;
        editMode = true;
    }

    function handleDoneClick() {
        send();
    }

    function keyDown(ev: KeyboardEvent) {
        if(ev.key == "Enter") {
            send();
        }
    }

    async function send() {
        let value: string | boolean = inputType === "checkbox" ? draftChecked : content;
        let p: Promise<boolean> = callback(value);
        if(await p) {
            if(inputType === "checkbox") {
                checked = draftChecked;
            }
            editMode = false;
        }
    }

</script>


<div class="d-flex {inputType === "checkbox" ? "align-items-center" : ""}">
    {#if actualEditRights}
        {#if !editMode}
            <span class="flex-fill">{inputType === "checkbox" ? (checked ? trueLabel : falseLabel) : content}</span>
            <button class="btn btn-link p-0 ps-2" type="button" onclick={handleEditClick}><BootstrapVectorIcon style="height: 2em; width: 2em;" icon={"pencil-square"}></BootstrapVectorIcon></button>
        {:else}
            {#if inputType === "checkbox"}
                <label class="flex-fill">
                    <input type="checkbox" bind:checked={draftChecked} />
                    {checkboxLabel}
                </label>
            {:else if multiline}
                <textarea class="flex-fill" bind:value={content}></textarea>
            {:else}
                <input class="flex-fill" type="text" bind:value={content} onkeyup={keyDown} />
            {/if}
            
            <button class="btn btn-link p-0 ps-2" type="button" onclick={handleDoneClick}><BootstrapVectorIcon style="height: 2em; width: 2em;" icon={"check-square"}></BootstrapVectorIcon></button>
        {/if}
    {:else}
        <span class="flex-fill">{inputType === "checkbox" ? (checked ? trueLabel : falseLabel) : content}</span>
    {/if}
</div>